import Vue from 'vue'
import App from './App.vue'
import ElementUI from "element-ui";
import "@/styles/index.scss";
import locale from 'element-ui/lib/locale/lang/th'
import router from './router'


Vue.config.productionTip = false
Vue.use(ElementUI, {
  locale,
});


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
